import React from 'react';
import ViewTableHeaderColumn from 'app/shared/view-table/view-table-header-column';
import ManagableTable from 'app/shared/view-table/managable-table';
import { FileWrapper } from 'app/shared/model/shared.model';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { fetchCaseActAttachmentsQuery } from 'app/edozvola/cases/case-acts/service/case-acts.queries';
import { CaseActAttachmentView } from 'app/edozvola/cases/case-acts/model/case-acts.model';
import { previewCaseActAttachment } from 'app/edozvola/cases/case-acts/service/case-act.service';
import { TooltipWrapper } from 'edozvola-frontend-lib/dist/ui/components/tooltipwrapper';
import { useNavigate } from 'react-router-dom';
import { openFileInNewWindow } from 'app/shared/util/navigation-util';

const ActAttachmentsTable = ({ idCaseAct }) => {
  const navigate = useNavigate()

  const openFileInNewTable = (caseActAttachment: CaseActAttachmentView) => {
    previewCaseActAttachment(caseActAttachment.idCaseActAttachment).then((document: FileWrapper) => {
      if (document) {
        openFileInNewWindow(document.url);
      }
    });
  };

  const renderTableRow = (value: CaseActAttachmentView, caseActAttachmentIndex: number, setFieldValue) => {
    return (
      <tr key={caseActAttachmentIndex}>
        <td className={'nowrap-column'}>
          <span>{value.name}</span>
        </td>
        <td>
          <div className={'actions-container'}>
            <TooltipWrapper message="Pregledaj dokument">
              <FontAwesomeIcon icon={'file'} className={'icon-table'} onClick={() => openFileInNewTable(value)} />
            </TooltipWrapper>
          </div>
        </td>
      </tr>
    );
  };

  return (
    <>
      <ManagableTable
        renderTableRow={renderTableRow}
        noDataMessage={'Nema priloga'}
        initialPaginationColumn={'name'}
        fetchDataQuery={fetchCaseActAttachmentsQuery}
        fetchDataProps={[idCaseAct]}
      >
        <ViewTableHeaderColumn renderSort sortKey={'name'} columnLabels={['Naziv priloga']} />
        <ViewTableHeaderColumn renderSort={false} columnLabels={['Prilog']} width={'75px'} />
      </ManagableTable>
    </>
  );
};

export default ActAttachmentsTable;
